export default __webpack_public_path__ + "static/media/LENS_CULINARIS_TEKAY_6.cdc36fe0.jpg";